import { render, staticRenderFns } from "./MobileDepoimentosComponent.vue?vue&type=template&id=04f987e6&lang=pug&"
var script = {}
import style0 from "./MobileDepoimentosComponent.vue?vue&type=style&index=0&id=04f987e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports